import React, { useEffect, useState } from 'react';
import { getUtmParamsFromUrl, saveUtmParams, getSavedUtmParams } from './utils/utm';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';
import PageTitle from './Components/common/PageTitle';
import Home from './Components/Home/Home';
import Blogs from './Components/Blogs/Blogs';
import WhyMaxiom from './Components/WhyMaxiom/WhyMaxiom';
import Header from './Components/Header';
import JEWELTop350 from './Components/WealthManagement/PMS/JEWELTop350/JEWELTop350';
import Spark351 from './Components/WealthManagement/PMS/Spark351/Spark351';
import Coral from './Components/WealthManagement/PMS/Coral/Coral';
import PMS from './Components/WealthManagement/PMS/PMS';
import GEM from './Components/WealthManagement/PMS/GEM/GEM';
import EMERALDE from './Components/WealthManagement/PMS/EMERALDE/EMERALDE';
import EMERALDNE from './Components/WealthManagement/PMS/EMERALDNE/EMERALDNE';
import Diamond from './Components/WealthManagement/PMS/Diamond/Diamond';
import Calculators from './Components/Resources/Calculators/Calculators';
import CAGR from './Components/Resources/Calculators/calculate/CAGR/CAGR';
import CompoundInterest from './Components/Resources/Calculators/calculate/CompoundInterest/CompoundInterest';
import FD from './Components/Resources/Calculators/calculate/FD/FD';
import PPF from './Components/Resources/Calculators/calculate/PPF/PPF';
import RD from './Components/Resources/Calculators/calculate/RD/RD';
import SimpleInterest from './Components/Resources/Calculators/calculate/SimpleInterest/SimpleInterest';
import SIP from './Components/Resources/Calculators/calculate/SIP/SIP';
import SIPDelay from './Components/Resources/Calculators/calculate/SIPDelay/SIPDelay';
import SIPGrowth from './Components/Resources/Calculators/calculate/SIPGrowth/SIPGrowth';
import WeightedReturns from './Components/Resources/Calculators/calculate/WeightedReturns/WeightedReturns';
import MF from './Components/Resources/Calculators/calculate/MF/MF';
import ELSS from './Components/Resources/Calculators/calculate/ELSS/ELSS';
import LSum from './Components/Resources/Calculators/calculate/LSum/LSum';
import SWP from './Components/Resources/Calculators/calculate/SWP/SWP';
import FV from './Components/Resources/Calculators/calculate/FV/FV';
import EPF from './Components/Resources/Calculators/calculate/EPF/EPF';
import Sukanya from './Components/Resources/Calculators/calculate/Sukanya/Sukanya';
import PR from './Components/Resources/Calculators/calculate/PR/PR';
import SR from './Components/Resources/Calculators/calculate/SR/SR';
import DY from './Components/Resources/Calculators/calculate/DY/DY';
import GI from './Components/Resources/Calculators/calculate/GI/GI';
import BFC from './Components/Resources/Calculators/calculate/BFC/BFC';
import CCPC from './Components/Resources/Calculators/PersonalCalculate/CCPC/CCPC';
import DRC from './Components/Resources/Calculators/PersonalCalculate/DRC/DRC';
import EFC from './Components/Resources/Calculators/PersonalCalculate/EFC/EFC';
import SGC from './Components/Resources/Calculators/PersonalCalculate/SGC/SGC';
import NWC from './Components/Resources/Calculators/PersonalCalculate/NWC/NWC';
import AgingParents from './Components/Resources/Calculators/GoalsCalculate/AgingParents/AgingParents';
import ChildEducation from './Components/Resources/Calculators/GoalsCalculate/ChildEducation/ChildEducation';
import ChildMarriage from './Components/Resources/Calculators/GoalsCalculate/ChildMarriage/ChildMarriage';
import CustomGoals from './Components/Resources/Calculators/calculate/CustomGoals/CustomGoals';
import DreamWedding from './Components/Resources/Calculators/GoalsCalculate/DreamWedding/DreamWedding';
import FirstCar from './Components/Resources/Calculators/GoalsCalculate/FirstCar/FirstCar';
import FirstCrore from './Components/Resources/Calculators/GoalsCalculate/FirstCrore/FirstCrore';
import HomeGoal from './Components/Resources/Calculators/GoalsCalculate/HomeGoal/HomeGoal';
import OverseasVacation from './Components/Resources/Calculators/GoalsCalculate/OverseasVacation/OverseasVacation';
import MutualFundsPricing from './Components/Pricing/MutualFundsPricing';
import RecurringWorldTour from './Components/Resources/Calculators/GoalsCalculate/RecurringWorldTour/RecurringWorldTour';
import CarLoan from './Components/Resources/Calculators/LoansCalculate/CarLoan/CarLoan';
import EMI from './Components/Resources/Calculators/LoansCalculate/EMI/EMI';
import HomeLoan from './Components/Resources/Calculators/LoansCalculate/HomeLoan/HomeLoan';
import PersonalLoan from './Components/Resources/Calculators/LoansCalculate/PersonalLoan/PersonalLoan';
import EducationLoan from './Components/Resources/Calculators/LoansCalculate/EducationLoan/EducationLoan';
import RenovationLoan from './Components/Resources/Calculators/LoansCalculate/RenovationLoan/RenovationLoan';
import LandConstruction from './Components/Resources/Calculators/LoansCalculate/LandConstruction/LandConstruction';
import MarriageLoan from './Components/Resources/Calculators/LoansCalculate/MarriageLoan/MarriageLoan';
import RetirementPlan from './Components/Resources/Calculators/RetirementCalculate/RetirementPlan/RetirementPlan';
import Superannuation from './Components/Resources/Calculators/RetirementCalculate/Superannuation/Superannuation';
import FIRE from './Components/Resources/Calculators/RetirementCalculate/FIRE/FIRE';
import GratuityEstimator from './Components/Resources/Calculators/RetirementCalculate/GratuityEstimator/GratuityEstimator';
import StudentLoan from './Components/Resources/Calculators/CareerCalculate/StudentLoan/StudentLoan';
import CareerGrowth from './Components/Resources/Calculators/CareerCalculate/CareerGrowth/CareerGrowth';
import CapitalGains from './Components/Resources/Calculators/TaxCalculate/CapitalGains/CapitalGains';
import RentalYield from './Components/Resources/Calculators/IncomeCalculate/RentalYield/RentalYield';
import IrregularCash from './Components/Resources/Calculators/IncomeCalculate/IrregularCash/IrregularCash';
import Margin from './Components/Resources/Calculators/TradingCalculate/Margin/Margin';
import OptionValue from './Components/Resources/Calculators/TradingCalculate/OptionValue/OptionValue';
import Brokerage from './Components/Resources/Calculators/TradingCalculate/Brokerage/Brokerage';
import Eligible from './Components/Resources/Calculators/LoansCalculate/Eligible/Eligible';
import Balance from './Components/Resources/Calculators/LoansCalculate/Balance/Balance';
import PoorFunds from './Components/Resources/Calculators/MiscellaneousCalculate/PoorFunds/PoorFunds';
import Inflation from './Components/Resources/Calculators/MiscellaneousCalculate/Inflation/Inflation';
import SingleAmount from './Components/Resources/Calculators/MiscellaneousCalculate/SingleAmount/SingleAmount';
import Ebidta from './Components/Resources/Calculators/MiscellaneousCalculate/Ebidta/Ebidta';
import Topup from './Components/Resources/Calculators/LoansCalculate/Topup/Topup';
import HRA from './Components/Resources/Calculators/TaxCalculate/HRA/HRA';
import GST from './Components/Resources/Calculators/TaxCalculate/GST/GST';
import Freelancer from './Components/Resources/Calculators/TaxCalculate/Freelancer/Freelancer';
import TravelBudget from './Components/Resources/Calculators/GoalsCalculate/TravelBudget/TravelBudget';
import WeddingBudget from './Components/Resources/Calculators/GoalsCalculate/WeddingBudget/WeddingBudget';
import HomeRenovation from './Components/Resources/Calculators/GoalsCalculate/HomeRenovation/HomeRenovation';
import Pricing from './Components/Pricing/Pricing';
import ContactUs from './Components/ContactUs';
import StocksPricing from './Components/Pricing/StocksPricing';
import PMSPricing from './Components/Pricing/PMSPricing';
import AlternateInvestments from './Components/WealthManagement/AlternateInvestments/AlternateInvestments';
import TaxPlanning from './Components/WealthManagement/TaxPlanning/TaxPlanning';
import EstatePlanning from './Components/WealthManagement/EstatePlanning/EstatePlanning';
import OffshoreProducts from './Components/WealthManagement/OffshoreProducts/OffshoreProducts';
import ScrollToTop from './Components/ScrollToTop';
import PrivateEquity from './Components/WealthManagement/PrivateEquity/PrivateEquity';
import PrivateCredit from './Components/WealthManagement/PrivateCredit/PrivateCredit';
import GoalBasedInvestments from './Components/FinancialAdvisory/GoalBasedInvestments/GoalBasedInvestments';
import FinancialPlanning from './Components/FinancialAdvisory/FinancialPlanning/FInancialPlanning';
import RetirementPlanning from './Components/FinancialAdvisory/RetirementPlanning/RetirementPlanning';
import TRetirementPlanning from './Components/FinancialAdvisory/RetirementPlanning/TRetirementPlanning/TRetirementPlanning';
import PostRetirement from './Components/FinancialAdvisory/RetirementPlanning/PostRetirement/PostRetirement';
import FIREPlanning from './Components/FinancialAdvisory/RetirementPlanning/FIREPlanning/FIREPlanning';
import Pension from './Components/Resources/Calculators/RetirementCalculate/Pension/Pension';
import PostRetirementExpenses from './Components/Resources/Calculators/RetirementCalculate/PostRetirement/PostRetirementExpenses';
import ReverseMortagage from './Components/Resources/Calculators/RetirementCalculate/ReverseMortagage/ReverseMortagage';
import NPSReinvestment from './Components/Resources/Calculators/RetirementCalculate/NPSReinvestment/NPSReinvestment';
import NPS from './Components/Resources/Calculators/RetirementCalculate/NPS/NPS';
import CorporateFinancialWellness from './Components/FinancialAdvisory/CorporateFinancialWellness/CorporateFinancialWellness';
import UGIndia from './Components/FinancialAdvisory/FinancialPlanning/FPEducation/UGIndia/UGIndia';
import UGAbroad from './Components/FinancialAdvisory/FinancialPlanning/FPEducation/UGAbroad/UGAbroad';
import MToChild from './Components/FinancialAdvisory/FinancialPlanning/FPEducation/MToChild/MToChild';
import PGMasters from './Components/FinancialAdvisory/FinancialPlanning/FPEducation/PGMasters/PGMasters';
import SportsP from './Components/FinancialAdvisory/FinancialPlanning/FPProfessionals/SportsP/SportsP';
import RBEmp from './Components/FinancialAdvisory/FinancialPlanning/FPProfessionals/RBEmp/RBEmp';
import Doctors from './Components/FinancialAdvisory/FinancialPlanning/FPProfessionals/Doctors/Doctors';
import EntreP from './Components/FinancialAdvisory/FinancialPlanning/FPProfessionals/EntreP/EntreP';
import ChildBirth from './Components/FinancialAdvisory/FinancialPlanning/FPLife/ChildBirth/ChildBirth';
import ChildMar from './Components/FinancialAdvisory/FinancialPlanning/FPLife/ChildMarriage/ChildMar';
import DeathIncomeEarner from './Components/FinancialAdvisory/FinancialPlanning/FPLife/DeathIncomeEarner/DeathIncomeEarner';
import Disability from './Components/FinancialAdvisory/FinancialPlanning/FPLife/Disability/Disability';
import Divorce from './Components/FinancialAdvisory/FinancialPlanning/FPLife/Divorce/Divorce';
import SingleParent from './Components/FinancialAdvisory/FinancialPlanning/FPLife/SingleParent/SingleParent';
import SingleMother from './Components/FinancialAdvisory/FinancialPlanning/FPLife/SingleMother/SingleMother';
import RetIndia from './Components/FinancialAdvisory/FinancialPlanning/FPLife/RetIndia/RetIndia';
import MigIndia from './Components/FinancialAdvisory/FinancialPlanning/FPLife/MigIndia/MigIndia';
import HealthEme from './Components/FinancialAdvisory/FinancialPlanning/FPLife/HealthEme/HealthEme';
import FPLife from './Components/FinancialAdvisory/FinancialPlanning/FPLife/FPLife';
import FPP from './Components/FinancialAdvisory/FinancialPlanning/FPProfessionals/FPP';
import FPEducation from './Components/FinancialAdvisory/FinancialPlanning/FPEducation/FPEducation';
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsConditions from './Components/TermsConditions';
import Meeting from './Components/Meeting';
import Knowledge from './Components/Knowledge/Knowledge';
import GoToTop from './Components/GoToTop';
import News from './Components/WhyMaxiom/News';
import Solution from './Components/Home/Solution';
import Colors from './Components/Colors';
import RootsWings from './Components/WhyMaxiom/RootsWings/RootsWings';
import ThreeLens from './Components/WhyMaxiom/ThreeLens/ThreeLens';
import LSG from './Components/WhyMaxiom/LSG/LSG';
import AIDriven from './Components/WhyMaxiom/AIDriven/AIDriven';
import Career from './Components/Career/Career';
import SalesFull from './Components/Career/Jobs/Sales/SalesFull';
import Ops from './Components/Career/Jobs/Ops/Ops';
import Dev from './Components/Career/Jobs/Dev/Dev';
import Srm from './Components/Career/Jobs/Srm/Srm';
import InvestorCenter from './Components/InvestorCenter/InvestorCenter';
import StickyQRDownload from './Components/StickyQRDownload';
import ComingSoon from './Components/ComingSoon';

const TransitionHandler = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // If navigation is marked as instant, prevent any transition delay
    if (location.state?.instant) {
      document.body.style.overflow = 'auto';
      window.scrollTo(0, 0);
    }
  }, [location]);

  return children;
};
// Dynamic Canonical URL component
function CanonicalHelmet() {
  const location = useLocation();
  const canonicalUrl = `https://maxiomwealth.com${location.pathname.replace(/\/$/, '') || '/'}`;
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

function App() {
  // Google Analytics gtag.js integration
  useEffect(() => {
    // Avoid adding the script multiple times
    if (!document.getElementById('gtag-js')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-65XBH8W186';
      script.id = 'gtag-js';
      document.head.appendChild(script);

      // Inline gtag config script
      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-65XBH8W186');
      `;
      document.head.appendChild(inlineScript);
    }
  }, []);
  // UTM capture and Zoho SalesIQ integration
  useEffect(() => {
    // 1. Capture UTM params from URL and persist
    const utms = getUtmParamsFromUrl();
    if (Object.keys(utms).length > 0) {
      saveUtmParams(utms);
    }

    // 2. When Zoho SalesIQ is ready, set UTM params as custom fields
    function setZohoUtmFields() {
      const savedUtms = getSavedUtmParams();
      console.log('Sending to Zoho SalesIQ:', savedUtms); // <-- Added log
      if (window.$zoho && window.$zoho.salesiq && typeof window.$zoho.salesiq.visitor === 'object') {
        Object.entries(savedUtms).forEach(([key, value]) => {
          if (value) {
            window.$zoho.salesiq.visitor.custom(key, value);
          }
        });
      }
    }

    // Zoho SalesIQ exposes a 'ready' callback
    if (window.$zoho && window.$zoho.salesiq) {
      if (typeof window.$zoho.salesiq.ready === 'function') {
        window.$zoho.salesiq.ready(setZohoUtmFields);
      } else {
        // If not ready yet, poll until it is
        const interval = setInterval(() => {
          if (window.$zoho && window.$zoho.salesiq && typeof window.$zoho.salesiq.ready === 'function') {
            window.$zoho.salesiq.ready(setZohoUtmFields);
            clearInterval(interval);
          }
        }, 500);
      }
    }
  }, []);
  // Inject Zoho SalesIQ script once
  useEffect(() => {
    if (!document.getElementById('zsiqscript')) {
      // Create the initialization script
      const initScript = document.createElement('script');
      initScript.innerHTML = `window.$zoho=window.$zoho || {}; $zoho.salesiq=$zoho.salesiq||{ready:function(){}}`;
      document.body.appendChild(initScript);
      // Create the Zoho widget script
      const zohoScript = document.createElement('script');
      zohoScript.id = 'zsiqscript';
      zohoScript.src = 'https://salesiq.zohopublic.com/widget?wc=siqc8770e70179e8e9fcf63be87cd1adf6f';
      zohoScript.defer = true;
      document.body.appendChild(zohoScript);
    }
    // Add custom CSS for widget position (halfway down right side)
    const styleId = 'zoho-custom-style';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        /* Override Zoho widget position: right, halfway down */
        #zsiqwidget { top: 50vh !important; right: 0 !important; left: auto !important; transform: translateY(-50%) !important; }
        /* For floating button, if needed */
        .zsiq_floatmain { top: 50vh !important; right: 0 !important; left: auto !important; transform: translateY(-50%) !important; }
      `;
      document.head.appendChild(style);
    }
  }, []);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Remove unused backend test
  }, []);

  return (
    <Router>
      <CanonicalHelmet />
      <div className="App">
        <ScrollToTop />
        <TransitionHandler>
          <Header />
          <Routes>
            <Route path="/" element={
              <>
                <PageTitle title="Maxiom Wealth - Financial Planning & Investment Solutions" />
                <Home />
              </>
            } />
            <Route path="/why-maxiom" element={
              <>
                <PageTitle title="Why Choose Maxiom - Our Approach & Values" />
                <WhyMaxiom />
              </>
            } />
            <Route path="/aboutus/:section" element={
              <>
                <PageTitle title="Why Choose Maxiom" />
                <WhyMaxiom />
              </>
            } />
            <Route path="/meeting" element={
              <>
              <PageTitle title="Meeting"/>
              <Meeting />
              </>
            } />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/solution" element={<Solution />} />
            <Route path="/colors" element={<Colors />} />
            <Route path="/roots-wings" element={<RootsWings />} />
            <Route path="/three-lens" element={<ThreeLens />} />
            <Route path="/lsg" element={<LSG />} />
            <Route path="/ai-driven" element={<AIDriven />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/careers/sales" element={<SalesFull />} />
            <Route path="/careers/ops" element={<Ops />} />
            <Route path="/careers/dev" element={<Dev />} />
            <Route path="/careers/srm" element={<Srm />} />
            <Route path="/wealth-services/alternate-investments" element={<AlternateInvestments />} />
            <Route path="/wealth-services/portfolio-management" element={<PMS />}/>
            <Route path="/wealth-services/tax-planning" element={<TaxPlanning />} />
            <Route path="/wealth-services/estate-planning" element={<EstatePlanning />} />
            <Route path="/wealth-services/offshore-products" element={<OffshoreProducts />} />
            <Route path="/wealth-services/private-equity" element={<PrivateEquity />} />
            <Route path="/wealth-services/private-credit" element={<PrivateCredit />} />
            {/* <Route path="/mediacoverage/in-the-news/" element={<News />} /> */}
            <Route path="/financial-advisory/goal-based-investments" element={<GoalBasedInvestments />} />
            <Route path="/financial-advisory/financial-planning" element={<FinancialPlanning />} />
            <Route path="/financial-advisory/retirement-planning" element={<RetirementPlanning />} />
            <Route path="/services/retirement-planning-services" element={<TRetirementPlanning />} />
            <Route path="/services/post-retirement-solutions" element={<PostRetirement />} />
            <Route path="/services/financial-independence-early-retirement-planning-fire" element={<FIREPlanning />} />
            <Route path="/services/finanacial-wellness-solutions" element={<CorporateFinancialWellness />} />
            <Route path="/services/financial-planning-for-education-undergraduate-education-in-india" element={<UGIndia />} />
            <Route path="/services/financial-planning-for-education-undergraduate-education-abroad" element={<UGAbroad />} />
            <Route path="/services/financial-planning-for-leducation-tips-on-sending-money-to-child-overseas" element={<MToChild />} />
            <Route path="/services/financial-planning-for-education-masters-education-abroad" element={<PGMasters />} />
            <Route path="/services/customised-financial-planning-for-professionals-sports-persons" element={<SportsP />} />
            <Route path="/services/customised-financial-planning-for-professionals-retired-bank-employees" element={<RBEmp />} />
            <Route path="/services/customised-financial-planning-for-professionals-doctors" element={<Doctors />} />
            <Route path="/services/customised-financial-planning-for-professionals-enterpreneurs" element={<EntreP />} />
            <Route path="/services/financial-planning-for-life-situations-child-birth" element={<ChildBirth />} />
            <Route path="/services/financial-planning-for-life-situations-childs-marriage" element={<ChildMar />} />
            <Route path="/services/financial-planning-in-case-of-sudden-death-of-income-earner" element={<DeathIncomeEarner />} />
            <Route path="/services/financial-planning-for-life-situations-disability" element={<Disability />} />
            <Route path="/services/financial-planning-for-life-situations-divorce" element={<Divorce />} />
            <Route path="/services/financial-planning-for-single-parent" element={<SingleParent />} />
            <Route path="/services/financial-planning-for-life-situations-single-mothers" element={<SingleMother />} />
            <Route path="/services/financial-planning-for-those-returning-to-india" element={<RetIndia />} />
            <Route path="/services/financial-planning-for-life-situations-those-emigrating-from-india" element={<MigIndia />} />
            <Route path="/services/financial-planning-for-life-situations-health-emergency" element={<HealthEme />} />
            <Route path="/fee" element={<Pricing />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/blog/blog-list" element={<Blogs />} />
            <Route path="/mutual-funds-pricing" element={<MutualFundsPricing />} />
            <Route path="/stocks-pricing" element={<StocksPricing />} />
            <Route path="/pms-pricing" element={<PMSPricing />} />
            <Route path="/pms" element={<PMS />} />
            <Route path="/jewel-pms-large-midcap-focused" element={<JEWELTop350 />} />
            <Route path="/spark-pms-smallcap-5000-cr-cos" element={<Spark351 />} />
            <Route path="/gem-pms-quality-momentum" element={<GEM />} />
            <Route path="/pms/emerald-equity" element={<EMERALDE />} />
            <Route path="/pms/emerald-non-equity" element={<EMERALDNE />} />
            <Route path="/pms/diamond" element={<Diamond />} />
            <Route path="/pms/coral" element={<Coral />} />
            <Route path="/resources/calculators" element={
              <>
                <PageTitle title="Financial Calculators - Plan Your Investments & Savings" />
                <Calculators />
              </>
            } />
            <Route path="/resources/calculators/:section" element={<Calculators />} />
            <Route path="/resources/calculators/cagr" element={<CAGR />} />
            <Route path="/resources/calculators/compound-interest" element={<CompoundInterest />} />
            <Route path="/resources/calculators/fd" element={<FD />} />
            <Route path="/resources/calculators/ppf" element={<PPF />} />
            <Route path="/resources/calculators/rd" element={<RD />} />
            <Route path="/resources/calculators/simple-interest" element={<SimpleInterest />} />
            <Route path="/resources/calculators/sip" element={<SIP />} />
            <Route path="/resources/calculators/sip-delay" element={<SIPDelay />} />
            <Route path="/resources/calculators/sip-growth" element={<SIPGrowth />} />
            <Route path="/resources/calculators/weighted-returns" element={<WeightedReturns />} />
            <Route path="/resources/calculators/mutual-fund" element={<MF/>}/>
            <Route path="/resources/calculators/elss" element={<ELSS/>}/>
            <Route path="/resources/calculators/lumpsum" element={<LSum/>}/>
            <Route path="/resources/calculators/swp" element={<SWP/>}/>
            <Route path="/resources/calculators/fv" element={<FV/>}/>
            <Route path="/resources/calculators/epf" element={<EPF/>}/>
            <Route path="/resources/calculators/sukanya" element={<Sukanya/>}/>
            <Route path="/resources/calculators/pr" element={<PR/>}/>
            <Route path="/resources/calculators/sr" element={<SR/>}/>
            <Route path="/resources/calculators/dividend-yield" element={<DY/>}/>
            <Route path="/resources/calculators/gold-investment" element={<GI/>}/>
            <Route path="/resources/calculators/better-funds-checker" element={<BFC/>}/>
            <Route path="/resources/calculators/credit-card" element={<CCPC/>}/>
            <Route path="/resources/calculators/debt-repay" element={<DRC/>}/>
            <Route path="/resources/calculators/emergencyfund" element={<EFC/>}/>
            <Route path="/resources/calculators/savingsgoal" element={<SGC/>}/>
            <Route path="/resources/calculators/net-worth" element={<NWC/>}/>
            <Route path="/resources/calculators/aging-parents" element={<AgingParents />} />
            <Route path="/resources/calculators/child-education" element={<ChildEducation />} />
            <Route path="/resources/calculators/child-marriage" element={<ChildMarriage />} />
            <Route path="/resources/calculators/custom-goals" element={<CustomGoals />} />
            <Route path="/resources/calculators/dream-wedding" element={<DreamWedding />} />
            <Route path="/resources/calculators/first-car" element={<FirstCar />} />
            <Route path="/resources/calculators/first-crore" element={<FirstCrore />} />
            <Route path="/resources/calculators/home-goal" element={<HomeGoal />} />
            <Route path="/resources/calculators/overseas-vacation" element={<OverseasVacation />} />
            <Route path="/resources/calculators/recurring-world-tour" element={<RecurringWorldTour />} />
            <Route path="/resources/calculators/car-loan-emi" element={<CarLoan />} />
            <Route path="/resources/calculators/emi" element={<EMI />} />
            <Route path="/resources/calculators/home-loan-emi" element={<HomeLoan />} />
            <Route path="/resources/calculators/personal-loan-emi" element={<PersonalLoan />} />
            <Route path="/resources/calculators/education-loan-emi" element={<EducationLoan />} />
            <Route path="/resources/calculators/home-extension-loan" element={<RenovationLoan />} />
            <Route path="/resources/calculators/land-construction-loan" element={<LandConstruction />} />
            <Route path="/resources/calculators/marriage-loan" element={<MarriageLoan />} />
            <Route path="/resources/calculators/retirement-plan" element={<RetirementPlan />} />
            <Route path="/resources/calculators/superannuation" element={<Superannuation />} />
            <Route path="/resources/calculators/fire" element={<FIRE />} />
            <Route path="/resources/calculators/gratuity" element={<GratuityEstimator />} />
            <Route path="/resources/calculators/pension" element={<Pension />} />
            <Route path="/resources/calculators/postretirement" element={<PostRetirementExpenses />} />
            <Route path="/resources/calculators/reverse-mortgage" element={<ReverseMortagage />} />
            <Route path="/resources/calculators/nps-reinvestment" element={<NPSReinvestment />} />
            <Route path="/resources/calculators/nps" element={<NPS />} />
            <Route path="/resources/calculators/student-loan" element={<StudentLoan />} />
            <Route path="/resources/calculators/career-growth-planner" element={<CareerGrowth />} />
            <Route path="/resources/calculators/capital-gains-tax" element={<CapitalGains />} />
            <Route path="/resources/calculators/rental-yield" element={<RentalYield />} />
            <Route path="/resources/calculators/irregular-cash-flow" element={<IrregularCash />} />
            <Route path="/resources/calculators/margin" element={<Margin />} />
            <Route path="/resources/calculators/brokerage-cost-tool" element={<Brokerage />} />
            <Route path="/resources/calculators/option-value" element={<OptionValue />} />
            <Route path="/resources/calculators/loan-eligibility" element={<Eligible />} />
            <Route path="/resources/calculators/balance-transfer" element={<Balance />} />
            <Route path="/resources/calculators/top-up-loan" element={<Topup />} />
            <Route path="/resources/calculators/ebidta-margin" element={<Ebidta />} />
            <Route path="/resources/calculators/inflation" element={<Inflation />} />
            <Route path="/resources/calculators/single-amount" element={<SingleAmount />} />
            <Route path="/resources/calculators/fund-switch" element={<PoorFunds />} />
            <Route path="/resources/calculators/hra-exemption" element={<HRA />} />
            <Route path="/resources/calculators/gst" element={<GST />} />
            <Route path="/resources/calculators/freelancer-income-tax" element={<Freelancer />} />
            <Route path="/resources/calculators/travel-budget" element={<TravelBudget />} />
            <Route path="/resources/calculators/wedding-budget" element={<WeddingBudget />} />
            <Route path="/resources/calculators/home-renovation-budget" element={<HomeRenovation />} />
            <Route path="/resources/learning-center" element={
              <>
                <PageTitle title="Learning Center - Financial Education & Resources" />
                <Blogs />
              </>
            } />
            <Route path="/financial-planning/education" element={<FPEducation />} />
            <Route path="/financial-planning/professionals" element={<FPP />} />
            <Route path="/financial-planning/life-situations" element={<FPLife />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/investor-center" element={<InvestorCenter />} />
            <Route path="/stocks" element={<ComingSoon />} />
            <Route path="/header" element={
              <>
                <Header />
                <Home />
              </>
            } />
          </Routes>
          <StickyQRDownload />
        </TransitionHandler>
      </div>
    </Router>
  );
}

export default App;

